import { sessionManager } from '../auth/sessionManager';
import { client } from './client';

// Kept out of interceptor.js on purpose: client.js imports interceptor.js, so
// reaching for the client from there would close an import cycle.
export const ENTRY_REDEEM_URL = '/v3/hrm/service/entry/redeem';

/**
 * Exchanges the single-use entry code from the URL for the session values.
 *
 * The partner entry URL used to carry the access token itself, which meant the
 * address bar, the history and every Referer header held a working credential.
 * It now carries only a code that dies on first use, so the token never reaches
 * the browser through the URL.
 *
 * @returns {Promise<object|null>} the redeemed entry values, or null when no
 *   session was established
 */
export const redeemEntryCode = async code => {
  if (!code) {
    return null;
  }

  const response = await client.post(ENTRY_REDEEM_URL, { code });
  const entry = response?.data;

  if (!entry?.tokenValue) {
    return null;
  }

  sessionManager.setToken(entry.tokenValue);
  if (entry.deviceId) {
    sessionManager.setDeviceId(entry.deviceId);
  }
  if (entry.managerId) {
    sessionManager.setUserId(entry.managerId);
  }

  return entry;
};
